module.exports = "<div *ngIf=\"videoBuffering\" [class]=\"spinner\"></div>\n"